import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-184ee7ad"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "ai-canvas__preloader"
}

import { computed, onMounted, ref, watch, PropType } from 'vue';
import { fabric } from 'fabric';
import { TMode } from '@/types/TMode';
import { ICanvasImage } from '@/types/ICanvasImage';
import { rotateCursor } from '@/assets/icons/canvas/rotateCursor';
// import { svgDeletePath } from '@/assets/icons/canvas/svgDeletePath';
// import { svgToBottomPath } from '@/assets/icons/canvas/svgToBottomPath';
// import { svgToTopPath } from '@/assets/icons/canvas/svgToTopPath';
import { cloneDeep } from 'lodash';
import AiSceleton from '@/components/UI/AiSceleton/AiSceleton.vue';

// const { loading } = storeToRefs(useEditorStore());


export default /*#__PURE__*/_defineComponent({
  __name: 'AiCanvas',
  props: {
  images: {
    type: Array as PropType<ICanvasImage[]>,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
    required: false,
  },
  correction: {
    type: Boolean,
    default: false,
  },
  background: {
    type: String as PropType<string>,
    required: false,
  },
  restoreBackground: {
    type: String as PropType<string>,
    required: false,
  },
  height: {
    type: Number as PropType<number>,
    required: true,
  },
  width: {
    type: Number as PropType<number>,
    required: true,
  },
  mode: {
    type: String as PropType<TMode>,
    required: false,
    default: 'move',
  },
  addLines: {
    type: Boolean as PropType<boolean>,
    required: false,
    default: false,
  },
  resetExistingImageTransformsOnChangeImages: {
    type: Boolean as PropType<boolean>,
    default: true,
  },
  brushSize: {
    type: Number as PropType<number>,
    required: false,
  },
  activeZoom: {
    type: Number as PropType<number>,
    required: true,
  },
  showControls: {
    type: Boolean as PropType<boolean>,
    default: true,
  },
  bgCover: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
},
  emits: ['canvasUpdate', 'deleteProduct', 'activeZoomSet'],
  setup(__props, { expose: __expose, emit: emits }) {

const props = __props;



let canvasOrig: any = null;
const canvasSetings: any = {
  preserveObjectStacking: true,
  selection: false,
};



const can = ref<any>(null);
const canWrapper = ref<any>(null);
// const activeZoom = ref<number>(1);
const minZoom = ref<number>(1);
const brushSize = ref<number>(props.brushSize || 30);
const loading = ref<boolean>(true);

const activeHeight = computed(() => props.height);
const activeWidth = computed(() => props.width);

// const history = ref<any[]>([]);
// const isRedoing = ref<boolean>(false);

const initCanvas = (): void => {
  if (can.value) {
    const canvas = canvasOrig || new fabric.Canvas(can.value, canvasSetings);
    canvas.rotationCursor = 'default';
    canvasOrig = canvas;
    const svgRotateIcon = encodeURIComponent(rotateCursor);
    const rotateIcon = `data:image/svg+xml;utf8,${svgRotateIcon}`;
    const imgIcon = document.createElement('img');
    imgIcon.src = rotateIcon;

    fabric.Object.prototype.controls.mtr = new fabric.Control({
      x: 0.5,
      y: 0,
      offsetX: 20,
      offsetY: 0,
      cursorStyle: `url("data:image/svg+xml;charset=utf-8,${svgRotateIcon}") 12 12, crosshair`,
      // @ts-ignore
      actionHandler: fabric.controlsUtils.rotationWithSnapping,
      actionName: 'rotate',
      withConnection: true,
    });
    fabric.Object.prototype.controls.mt.visible = false;
    fabric.Object.prototype.controls.mr.visible = false;
    fabric.Object.prototype.controls.mb.visible = false;
    fabric.Object.prototype.controls.ml.visible = false;

    canvasOrig?.setWidth(activeWidth.value);
    canvasOrig?.setHeight(activeHeight.value);
    canvasOrig?.clear();

    if (props.restoreBackground) {
      fabric.Image.fromURL(
        props.restoreBackground,
        (img: any) => {
          img.set({
            erasable: true,
            selectable: false,
            objectType: 'background-restore',
          });

          // canvasOrig.add(img);
          canvasOrig.sendToBack(img);
          // canvasOrig.renderAll();
          canvasOrig.isDrawingMode = true;
          // @ts-ignore
          canvasOrig.freeDrawingBrush = new fabric.EraserBrush(canvasOrig);
          canvasOrig.freeDrawingBrush.width = 80000;
          setTimeout(() => {
            const event = new MouseEvent('mousedown', {
              bubbles: true,
              cancelable: true,
              view: window,
            });
            console.log(-1);
            canvasOrig.upperCanvasEl.dispatchEvent(event);
            setTimeout(() => {
              const event1 = new MouseEvent('mouseup', {
                bubbles: true,
                cancelable: true,
                view: window,
              });
              console.log(0);
              canvasOrig.upperCanvasEl.dispatchEvent(event1);
              canvasOrig.freeDrawingBrush.width = brushSize.value;
              console.log(1);
              renderBackground();
            }, 200);
          }, 200);
          // }, 100);
        },
        { crossOrigin: 'anonymous' },
      );
    }

    if (props.background && !props.restoreBackground) {
      renderBackground();
    }
    props.images.forEach((image: ICanvasImage) => {
      addImageToCanvas(image);
    });
    setTimeout(() => {
      canvasOrig.getObjects().filter((object: any) => object.objectType === 'shadow')
        .forEach((object: any) => {
          object.sendToBack();
        });
      canvasOrig.getObjects().filter((object: any) => object.objectType === 'line')
        .forEach((object: any) => {
          object.sendToBack();
        });
      canvasOrig.getObjects().filter((object: any) => object.objectType === 'background')
        .forEach((object: any) => {
          object.sendToBack();
        });
    }, 100);

    canvasOrig.on('mouse:up', async () => {
      setTimeout(() => {
        canvasUpdateData();
      }, 100);
    });

    canvasOrig.on('object:moving', (e: any): void => {
      const obj = e.target;
      const { left, top } = obj;

      obj.setCoords();
      const boundLeft = obj.getBoundingRect().left / props.activeZoom;
      const boundTop = obj.getBoundingRect().top / props.activeZoom;
      const boundWidth = obj.getBoundingRect().width / props.activeZoom;
      const boundHeight = obj.getBoundingRect().height / props.activeZoom;
      if (boundLeft + boundWidth * 0.7 < 0 || boundLeft + boundWidth * 0.3 > activeWidth.value) {
        obj.left = obj.lastLeft;
      } else {
        obj.lastLeft = left;
      }
      if (boundTop + boundHeight * 0.7 < 0 || boundTop + boundHeight * 0.3 > activeHeight.value) {
        obj.top = obj.lastTop;
      } else {
        obj.lastTop = top;
      }
      canvasOrig.renderAll();
    });

    // canvasOrig.on('object:added', () => {
    //   if (!isRedoing.value) {
    //     history.value = [];
    //   }
    //   isRedoing.value = false;
    // });
  }
};

const addLinesToCanvas = (): void => {
  canvasOrig
    .getObjects()
    .filter((object: any) => object.objectType === 'line')
    .forEach((obj: any) => {
      canvasOrig.remove(obj);
    });
  const grid = 3;
  for (let i = 1; i < grid; i++) {
    const line1: any = new fabric.Line(
      [(activeWidth.value / grid) * i, 0, (activeWidth.value / grid) * i, activeHeight.value],
      {
        stroke: 'rgba(132, 231, 35, 0.5)',
        strokeWidth: 1 / props.activeZoom,
        selectable: false,
      },
    );
    line1.objectType = 'line';
    const line2: any = new fabric.Line(
      [0, (activeHeight.value / grid) * i, activeWidth.value, (activeHeight.value / grid) * i],
      {
        stroke: 'rgba(132, 231, 35, 0.5)',
        strokeWidth: 1 / props.activeZoom,
        selectable: false,
      },
    );
    line2.objectType = 'line';
    canvasOrig?.add(line1);
    canvasOrig?.add(line2);
  }
};

const setImagesPosition = (): void => {
  const products = canvasOrig?.getObjects().filter((p: any) => p.objectType === 'product');
  canvasOrig?.clear();
  if (props.addLines) {
    addLinesToCanvas();
  }
  const canvasWtoHRatio = canvasOrig ? canvasOrig.getWidth() / canvasOrig.getHeight() : 0;
  products.forEach((product: any) => {
    const activeWidthtoHRatio = product.width / product.height;
    const k = props.showControls ? 2 : 1;
    if (canvasWtoHRatio < activeWidthtoHRatio) {
      product.scaleToWidth(canvasOrig ? canvasOrig.getWidth() / k : 0);
    } else {
      product.scaleToHeight(canvasOrig ? canvasOrig.getHeight() / k : 0);
    }
    canvasOrig?.add(product);
    canvasOrig?.viewportCenterObject(product);
  });
};

const addImageToCanvas = async (image: ICanvasImage): Promise<void> => {
  fabric.Image.fromURL(image?.image, (fabricImgBg: any) => {
    const imgSettings: any = {
      rotatingPointOffset: 30,
      cornerColor: '#fff',
      cornerStyle: 'circle',
      transparentCorners: false,
      borderColor: '#fff',
      lockScalingFlip: true,
      objectType: 'product',
      erasable: false,
      selectable: true,
    };
    if (image?.id) {
      imgSettings.productId = image.id;
    }
    if (image?.uid) {
      imgSettings.uid = image.uid;
    }

    const imgSettingsBg = {
      ...cloneDeep(imgSettings),
      erasable: false,
      selectable: false,
      objectType: 'shadow',
    };
    delete imgSettingsBg.productId;

    const canvasWtoHRatio = canvasOrig.getWidth() / canvasOrig.getHeight();
    const activeWidthtoHRatio = fabricImgBg.width / fabricImgBg.height;
    if (canvasWtoHRatio < activeWidthtoHRatio) {
      fabricImgBg.scaleToWidth(canvasOrig.getWidth() / props.activeZoom / (props.showControls ? 2 : 1));
    } else {
      fabricImgBg.scaleToHeight(canvasOrig.getHeight() / props.activeZoom / (props.showControls ? 2 : 1));
    }
    canvasOrig.add(fabricImgBg);

    if (image) {
      const { transform } = image;
      if (transform && transform.x) {
        fabricImgBg.left = transform.x;
        fabricImgBg.top = transform.y;
        fabricImgBg.scaleX = transform.scaleX;
        fabricImgBg.scaleY = transform.scaleY;
        fabricImgBg.angle = transform.angle;
        fabricImgBg.setCoords();
      } else {
        canvasOrig.viewportCenterObject(fabricImgBg);
      }
    }
    if (props.background && image?.mask) {
      fabricImgBg.clone((fabricImg: any) => {
        fabricImg.set(imgSettings);
        fabricImg.productId = image.id;
        canvasOrig.add(fabricImg);
        canvasOrig.bringToFront(fabricImgBg);
        setTimeout(() => {
          canvasOrig.bringToFront(fabricImg);
        }, 100);
      });
      fabricImgBg.globalCompositeOperation = 'destination-out';
      fabricImgBg.set(imgSettingsBg);
    } else {
      fabricImgBg.set(imgSettings);
    }
    if (!props.background) {
      canvasOrig.setActiveObject(fabricImgBg);
    }

    let pos = {
      left: 0,
      top: 0,
    };
    fabricImgBg.on('scaling', () => {
      if (fabricImgBg.getScaledWidth() >= activeWidth.value) {
        fabricImgBg.scaleX = activeWidth.value / (fabricImgBg?.width || 1);
        fabricImgBg.scaleY = activeWidth.value / (fabricImgBg?.width || 1);
        fabricImgBg.left = pos.left;
        fabricImgBg.top = pos.top;
      } else {
        pos = {
          left: fabricImgBg.left || 1,
          top: fabricImgBg.top || 1,
        };
      }
      if (fabricImgBg.getScaledHeight() >= activeHeight.value) {
        fabricImgBg.scaleX = activeHeight.value / (fabricImgBg?.height || 1);
        fabricImgBg.scaleY = activeHeight.value / (fabricImgBg?.height || 1);
        fabricImgBg.left = pos.left;
        fabricImgBg.top = pos.top;
      } else {
        pos = {
          left: fabricImgBg.left || 1,
          top: fabricImgBg.top || 1,
        };
      }
    });
  });
};

const renderBackground = (): void => {
  if (props.background) {
    fabric.Image.fromURL(
      props.background,
      (img: any) => {
        let bgRect: any = null;
        if (props.bgCover) {
          bgRect = new fabric.Rect({
            top: 0,
            left: 0,
            width: activeWidth.value,
            height: activeHeight.value,
            fill: '#fff',
            selectable: false,
            hoverCursor: 'default',
          });
          bgRect.objectType = 'bgRect';
          bgRect.erasable = true;
          canvasOrig.add(bgRect);
        }

        img.set({
          erasable: true,
          selectable: false,
          objectType: 'background',
        });

        canvasOrig.add(img);
        console.log(2);
        if (!props.restoreBackground) {
          canvasOrig.sendToBack(img);
          setTimeout(() => {
            if (bgRect) {
              canvasOrig.sendToBack(bgRect);
            }
            canvasOrig.renderAll();
          }, 100);
        }
      },
      { crossOrigin: 'anonymous' },
    );
  }
};

const setCanvasZoom = (ratio: number): void => {
  canvasOrig?.setWidth(activeWidth.value * ratio);
  canvasOrig?.setHeight(activeHeight.value * ratio);
  canvasOrig?.setZoom(ratio);
  if (canvasOrig) {
    canvasOrig.freeDrawingCursor = `url(${getDrawCursor(brushSize.value * props.activeZoom)}) ${
      (brushSize.value * props.activeZoom) / 2
    } ${(brushSize.value * props.activeZoom) / 2}, crosshair`;
  }
  // showButtonsForObject();
};

const setCanvasDefaultZoom = (): void => {
  const canvasWtoHRatio = activeWidth.value / activeHeight.value;
  const wrapperWtoHRatio = canWrapper.value.clientWidth / canWrapper.value.clientHeight;
  let zoom: number;
  if (canvasWtoHRatio > wrapperWtoHRatio) {
    zoom = canWrapper.value.clientWidth / activeWidth.value;
  } else {
    zoom = canWrapper.value.clientHeight / activeHeight.value;
  }
  emits('activeZoomSet', zoom);
  // activeZoom.value = zoom;
  setCanvasZoom(zoom);
  minZoom.value = zoom;
};

const changeImageOrder = (id: string, nextProductId?: string, prevProductId?: string): void => {
  const productIndex = canvasOrig._objects.findIndex((p: any) => p.productId === id);
  const product = productIndex !== -1 ? canvasOrig._objects[productIndex] : null;
  const nextProductIndex = nextProductId
    ? canvasOrig._objects.findIndex((p: any) => p.productId === nextProductId)
    : -1;
  const prevProductIndex = prevProductId
    ? canvasOrig._objects.findIndex((p: any) => p.productId === prevProductId)
    : -1;
  if (product && (prevProductIndex !== -1 || nextProductIndex !== -1)) {
    canvasOrig._objects.splice(productIndex, 1);
    canvasOrig._objects.splice(nextProductIndex === -1 ? prevProductIndex : nextProductIndex + 1, 0, product);
    canvasOrig.renderAll();
  }
};

const moveForvard = (uid: string): void => {
  const productIndex = canvasOrig._objects.findIndex((p: any) => p.uid === uid);
  if (productIndex >= 0 && productIndex < canvasOrig._objects.length - 1) {
    const element = canvasOrig._objects[productIndex];
    canvasOrig._objects.splice(productIndex, 1);
    canvasOrig._objects.splice(productIndex + 1, 0, element);
    canvasOrig.renderAll();
    canvasUpdateData();
  }
};

const moveBackward = (uid: string): void => {
  const productIndex = canvasOrig._objects.findIndex((p: any) => p.uid === uid);
  if (productIndex > 0 && productIndex < canvasOrig._objects.length) {
    const element = canvasOrig._objects[productIndex];
    canvasOrig._objects.splice(productIndex, 1);
    canvasOrig._objects.splice(productIndex - 1, 0, element);
    canvasOrig.renderAll();
    canvasUpdateData();
  }
};

const getBackground = async (): Promise<any> => {
  let result = {};
  // canvasOrig.setWidth(activeWidth.value * props.activeZoom);
  // canvasOrig.setHeight(activeHeight.value * props.activeZoom);
  canvasOrig.setWidth(activeWidth.value);
  canvasOrig.setHeight(activeHeight.value);
  canvasOrig.setZoom(1);
  const objectsToExclude = canvasOrig
    .getObjects()
    .filter((obj: any) => obj.objectType === 'button' || obj.objectType === 'line');
  objectsToExclude.forEach((e: any) => {
    canvasOrig.remove(e);
  });
  const base64 = canvasOrig.toDataURL({
    format: 'png',
  });
  objectsToExclude.forEach((e: any) => {
    canvasOrig.add(e);
  });
  canvasOrig.setWidth(activeWidth.value * props.activeZoom);
  canvasOrig.setHeight(activeHeight.value * props.activeZoom);
  canvasOrig.setZoom(props.activeZoom);
  // canvasOrig.setZoom(props.activeZoom);
  const img = new Image();
  img.src = base64;
  const resImg = await canvasProcess(img);
  const canvas = document.createElement('canvas');
  canvas.width = activeWidth.value;
  canvas.height = activeHeight.value;
  const ctx = canvas.getContext('2d');
  if (ctx) {
    ctx.drawImage(resImg, 0, 0, activeWidth.value, activeHeight.value);
    const enlargedBase64src = canvas.toDataURL('image/png');
    const imageData = ctx.getImageData(0, 0, activeWidth.value, activeHeight.value);
    const { data } = imageData;
    for (let i = 0; i < data.length; i += 4) {
      const a = data[i + 3];
      if (a < 180) {
        data[i] = 255;
        data[i + 1] = 255;
        data[i + 2] = 255;
        data[i + 3] = 255;
      } else {
        data[i] = 0;
        data[i + 1] = 0;
        data[i + 2] = 0;
        data[i + 3] = 255;
      }
    }
    ctx.putImageData(imageData, 0, 0);
    const enlargedBase64mask = canvas.toDataURL('image/png');
    result = {
      enlargedBase64mask,
      enlargedBase64src,
    };
  }
  return result;
};

const canvasProcess = (img: any): Promise<any> => new Promise((resolve, reject) => {
  if (img) {
    img.onload = () => resolve(img);
    img.onerror = reject;
  }
});

const changeCanvasModeHandler = (mode: TMode): void => {
  if (mode === 'move') {
    canvasOrig.isDrawingMode = false;
    canvasOrig.hoverCursor = 'move';
  } else if (mode === 'erase') {
    canvasOrig.discardActiveObject();
    // @ts-ignore
    canvasOrig.freeDrawingBrush = new fabric.EraserBrush(canvasOrig, {
      // straightLineKey: 'ctrlKey',
      drawStraightLine: false,
    });
    canvasOrig.freeDrawingBrush.width = brushSize.value;
    canvasOrig.freeDrawingCursor = `url(${getDrawCursor(brushSize.value * props.activeZoom)}) ${
      (brushSize.value * props.activeZoom) / 2
    } ${(brushSize.value * props.activeZoom) / 2}, crosshair`;
    canvasOrig.freeDrawingBrush.inverted = false;
    canvasOrig.isDrawingMode = true;
    canvasOrig.hoverCursor = 'none';
  } else if (mode === 'restore') {
    canvasOrig.discardActiveObject();
    // @ts-ignore
    canvasOrig.freeDrawingBrush = new fabric.EraserBrush(canvasOrig, {
      drawStraightLine: false,
    });
    canvasOrig.freeDrawingBrush.width = brushSize.value;
    canvasOrig.freeDrawingCursor = `url(${getDrawCursor(brushSize.value * props.activeZoom)}) ${
      (brushSize.value * props.activeZoom) / 2
    } ${(brushSize.value * props.activeZoom) / 2}, crosshair`;
    canvasOrig.freeDrawingBrush.inverted = true;
    canvasOrig.isDrawingMode = true;
    canvasOrig.hoverCursor = 'none';
  }
};

const changeBrushSize = (size: number): void => {
  brushSize.value = size;
  const eraser = canvasOrig.freeDrawingBrush;
  eraser.width = size;
  canvasOrig.freeDrawingCursor = `url(${getDrawCursor(brushSize.value * props.activeZoom)}) ${
    (brushSize.value * props.activeZoom) / 2
  } ${(brushSize.value * props.activeZoom) / 2}, crosshair`;
};

const updateCanvasProducts = (): void => {
  const currentProducts = canvasOrig.getObjects().filter((p: any) => p.objectType === 'product');
  const newProducts = props.images.filter(
    (image: ICanvasImage) => !currentProducts.find((currentProduct: any) => currentProduct.uid === image.uid),
  );
  newProducts.forEach((newProduct: ICanvasImage) => {
    addImageToCanvas(newProduct);
  });
  const productsToDelete = currentProducts.filter(
    (currentProduct: any) => !props.images.find((image: ICanvasImage) => currentProduct.uid === image.uid),
  );
  productsToDelete.forEach((product: any) => {
    canvasOrig.remove(product);
  });

  const updatedProducts = canvasOrig.getObjects().filter((p: any) => p.objectType === 'product');
  // eslint-disable-next-line max-len
  const imageKeys: Record<string, any> = props.images?.reduce((keys, image) => ({ ...keys, ...(image?.uid ? { [image.uid]: image } : {}) }), {}) || {};
  // eslint-disable-next-line max-len
  const newImageKeys: Record<string, any> = newProducts.reduce(
    (keys, image) => ({ ...keys, ...(image?.uid ? { [image.uid]: image } : {}) }),
    {},
  );

  updatedProducts.forEach((p: any) => {
    if (
      imageKeys[p.uid] && (props.resetExistingImageTransformsOnChangeImages
      || (!props.resetExistingImageTransformsOnChangeImages && newImageKeys[p.uid]))
    ) {
      p.left = imageKeys[p.uid as string].transform?.x;
      p.top = imageKeys[p.uid as string].transform?.y;
      p.scaleX = imageKeys[p.uid as string].transform?.scaleX;
      p.scaleY = imageKeys[p.uid as string].transform?.scaleY;
      p.angle = imageKeys[p.uid as string].transform?.angle;
      p.setCoords();
    }
  });
};

const getDrawCursor = (brushSizeInt: number): string => {
  const circle = `
    <svg
      height="${brushSizeInt}"
      fill="#000000"
      stroke="#ffffff"
      viewBox="0 0 ${brushSizeInt * 2} ${brushSizeInt * 2}"
      width="${brushSizeInt}"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="50%"
        cy="50%"
        r="${brushSizeInt}"
      />
    </svg>
  `;

  return `data:image/svg+xml;base64,${window.btoa(circle)}`;
};

const canvasUpdateData = async (): Promise<void> => {
  const products = canvasOrig?.getObjects()?.filter((p: any) => p.objectType === 'product');

  const productsFormatted = products.map((product: any) => ({
    productId: product.productId,
    uid: product.uid,
    transform: {
      x: product.left,
      y: product.top,
      scaleX: product.scaleX,
      scaleY: product.scaleY,
      angle: product.angle,
    },
  }));
  const productsData: any = {
    products: productsFormatted,
    activeProductId: canvasOrig?.getActiveObject()?.productId,
    activeProductUid: canvasOrig?.getActiveObject()?.uid,
  };
  // if (props.background) {
  //   const bg = await getBackground();
  //   productsData.mask = bg?.enlargedBase64mask;
  //   productsData.image = bg?.enlargedBase64src;
  // }
  emits('canvasUpdate', productsData);
};

const setActiveProduct = (uid: string): void => {
  const product = canvasOrig.getObjects().find((p: any) => p.uid === uid && p.objectType === 'product');
  canvasOrig.setActiveObject(product);
  canvasOrig.renderAll();
};

onMounted(async () => {
  initCanvas();

  setCanvasDefaultZoom();
  if (props.addLines) {
    addLinesToCanvas();
  }

  if (props.mode) {
    changeCanvasModeHandler(props.mode);
  }

  setTimeout(() => {
    // canvasUpdateData();
    loading.value = false;
  }, 100);
});

watch(brushSize, (newVal) => {
  changeBrushSize(newVal);
});

watch(
  computed(() => `${activeWidth.value}x${activeHeight.value}`),
  () => {
    setCanvasDefaultZoom();
    setImagesPosition();
    setTimeout(() => {
      if (props.addLines) {
        addLinesToCanvas();
      }
      canvasUpdateData();
    }, 100);
  },
);

watch(
  () => props.images,
  () => {
    updateCanvasProducts();
  },
  { deep: true },
);

watch(props, (newVal) => {
  changeCanvasModeHandler(newVal.mode);
});

watch(
  () => props.background,
  () => {
    if (props.background) {
      renderBackground();
    }
  },
);

watch(
  () => props.brushSize,
  () => {
    brushSize.value = props.brushSize || 30;
  },
);

watch(
  () => props.activeZoom,
  (newVal) => {
    setCanvasZoom(newVal);
  },
);

__expose({
  changeImageOrder,
  moveForvard,
  moveBackward,
  canvasUpdateData,
  getBackground,
  setActiveProduct,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "ai-canvas__wrapper",
    ref_key: "canWrapper",
    ref: canWrapper
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["ai-canvas__box", { 'ai-canvas__box--disabled': props.disabled }])
    }, [
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(AiSceleton, { class: "ai-canvas__sceleton" })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        ref_key: "canWrapper",
        ref: canWrapper,
        class: "ai-canvas__inner"
      }, [
        _createElementVNode("canvas", {
          class: "canvas",
          ref_key: "can",
          ref: can
        }, null, 512)
      ], 512)
    ], 2)
  ], 512))
}
}

})